import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { StatiManutenzioneComponent } from 'src/app/anagrafiche/stati-manutenzione/stati-manutenzione.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => StatoManutenzionePickerComponent) },
  ],
  selector: 'stato-manutenzione-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class StatoManutenzionePickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(StatiManutenzioneComponent, { data: { selectionMode: true } }).afterClosed();
  };

  public writeValue(value?: any): any {
    if (value) {
    this.parts.patchValue({ 
        humanIdentifier: value.nome,
        id: value.id 
    });
    }
    this.stateChanges.next();
  }
}
